!function(){function t(t,e){e=e||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),n}"function"!=typeof window.CustomEvent&&(t.prototype=window.Event.prototype,window.CustomEvent=t)}();



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/CustomEvent.js
// module id = 589
// module chunks = 11